import React, { memo } from 'react';

import { SharedReactionProps as Reaction } from '../../../types/SharedReactionProps';
import { UserAction } from '../../../types/UserAction';
import { Layout } from '../../Layout/Layout';
import { ReactionGroup } from '../../Reaction/subcomponents/ReactionGroup';
import { Text } from '../../Text/Text';
import { Card } from '../Card';

export interface Props {
  /** Card contents */
  children: React.ReactNode;
  /** Description for reactions */
  description: string;
  /** An array of reactions */
  reactions: Reaction[];
  /** Card title */
  title: string;
  /** Callback to handle updated reactions */
  onReact: (updatedReactions: Reaction[]) => void;
  /** Optional header actions */
  actions?: UserAction[];
  /** Enables single or multi reactions */
  isMulti?: boolean;
}

export const ReactionCard = memo(
  ({
    actions,
    children,
    description,
    isMulti,
    reactions,
    title,
    onReact,
  }: Props) => {
    const footer = {
      children: (
        <Layout align="center" preset="s">
          <Text preset="description">{description}</Text>
          <ReactionGroup
            isMulti={isMulti}
            reactions={reactions}
            onChange={onReact}
          />
        </Layout>
      ),
    };

    return (
      <Card
        footer={footer}
        header={{
          actions,
          title,
        }}
      >
        {children}
      </Card>
    );
  },
);
